// ─── Workshop Truck Availability Tracker ───
// Root application component — React Router + global state wiring
// IASL Technical Academy / Lafarge Driving Institute, Nigeria

import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/layout/Layout'
import ToastContainer from './components/ui/Toast'
import Dashboard from './views/Dashboard'
import AllTrucks from './views/AllTrucks'
import AvailabilityReport from './views/AvailabilityReport'
import StatusHistory from './views/StatusHistory'
import RepairCostReport from './views/RepairCostReport'
import Settings from './views/Settings'
import { useDashboard } from './hooks/useDashboard'
import { useToast } from './hooks/useToast'

function App() {
  // ── Global hooks ──────────────────────────────────────────
  const dashboard = useDashboard()
  const { toasts, addToast, dismissToast } = useToast()

  return (
    <>
      <Routes>
        <Route
          element={
            <Layout
              lastSynced={dashboard.lastSynced}
              isLoading={dashboard.isLoading}
              onRefresh={dashboard.refresh}
            />
          }
        >
          {/* Dashboard — receives live data + refresh + toast from App */}
          <Route
            path="/"
            element={
              <Dashboard
                data={dashboard.data}
                historyData={dashboard.historyData}
                isLoading={dashboard.isLoading}
                error={dashboard.error}
                refresh={dashboard.refresh}
                addToast={addToast}
              />
            }
          />

          {/* All Trucks — has its own useTrucks hook internally */}
          <Route path="/trucks" element={<AllTrucks addToast={addToast} />} />

          {/* Availability Report — receives history data */}
          <Route
            path="/report"
            element={
              <AvailabilityReport
                historyData={dashboard.historyData}
                isLoading={dashboard.isLoading}
              />
            }
          />

          {/* Status History — audit trail */}
          <Route path="/history" element={<StatusHistory addToast={addToast} />} />

          {/* Repair Cost Report */}
          <Route
            path="/costs"
            element={<RepairCostReport addToast={addToast} />}
          />

          {/* Settings */}
          <Route path="/settings" element={<Settings />} />

          {/* Catch-all → redirect to dashboard */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>

      {/* ── Global toast notifications ─────────────────────────── */}
      <ToastContainer toasts={toasts} onDismiss={dismissToast} />
    </>
  )
}

export default App
